import { Button, Popconfirm } from "antd";

type ReportDoneToggleProps = {
  reportDone: boolean | null | undefined;
  loading: boolean;
  onToggle: (value: boolean) => void;
};

export const ReportDoneToggle = ({ reportDone, loading, onToggle }: ReportDoneToggleProps) => {
  if (reportDone) {
    return (
      <Button size="small" type="text" loading={loading} onClick={() => onToggle(false)}>
        Mark as Not Sent
      </Button>
    );
  }
  return (
    <Popconfirm
      title="Mark Report as Sent"
      description="Confirm that the report for this work order has been provided to the customer."
      okText="Confirm"
      cancelText="Cancel"
      onConfirm={() => onToggle(true)}
    >
      <Button size="small" type="primary" loading={loading}>
        Mark Report Sent
      </Button>
    </Popconfirm>
  );
};
